// Shared ceiling for how many items a single generation run may produce.
// This is the one knob behind every count gate: the builder's typed count
// input, the generation server action, the Ask-AI program planner, the MCP
// agent tools, and each generator's internal defensive clamp all derive from
// it (fixed single-draft types like rubrics stay at exactly 1). Kept in a
// dependency-free module so generator internals can import it without pulling
// in the content-type registry.
export const MAX_GENERATION_COUNT = 25;
